var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H18C19.1046 4 20 4.89543 20 6V15C20 15.1821 19.9513 15.3529 19.8662 15.5H4.13378C4.0487 15.3529 4 15.1821 4 15V6C4 4.89543 4.89543 4 6 4ZM12.3192 5.76879C12.1972 5.47815 11.8033 5.47815 11.6812 5.76879L10.7934 7.88248C10.7428 8.0029 10.6342 8.08549 10.5092 8.09863L8.31436 8.32929C8.01258 8.36101 7.89085 8.75316 8.11719 8.9645L9.7633 10.5015C9.85708 10.5891 9.89856 10.7227 9.87186 10.8512L9.4032 13.1075C9.33876 13.4177 9.65744 13.6601 9.9194 13.5001L11.8246 12.3363C11.8788 12.3031 11.9395 12.2866 12.0002 12.2866C12.0609 12.2866 12.1216 12.3031 12.1759 12.3363L14.081 13.5001C14.343 13.6601 14.6617 13.4177 14.5972 13.1075L14.1286 10.8512C14.1019 10.7227 14.1433 10.5891 14.2371 10.5015L15.8832 8.9645C16.1096 8.75316 15.9879 8.36101 15.6861 8.32929L13.4913 8.09863C13.3662 8.08549 13.2576 8.0029 13.207 7.88248L12.3192 5.76879Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStar);
export default __webpack_public_path__ + "static/media/laptop-star.00e307ef81c575c70144913d86a82916.svg";
export { ForwardRef as ReactComponent };